import script from "./ScopesLevelSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ScopesLevelSelector.vue?vue&type=script&setup=true&lang=js"

import "./ScopesLevelSelector.vue?vue&type=style&index=0&id=05d255f8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d255f8"]])

export default __exports__